import * as React from "react";
import { useState, useEffect } from "react";
import { FxPopupOpener } from "../../fxms/windows/FxWindows";
import { FxResource } from "../../fxms/inputs/FxResource";

/**
 * 정보목록 공통 콤포넌트.
 * 개발자 : 김종훈.
 * 개발년월 : 2022.11.
 *
 * @returns
 */
export const FxInfoList = (props) => {
  const { title, inform } = props;
  const [selectedData, setSelectedData] = useState(null);
  const openRefMore = React.useRef(null);
  const openRefItem = React.useRef(null);

  function click(e) {
    if (e === "more") {
      openRefMore.current();
    } else {
      console.log("*** FxInfoList ***  click = ", e);
      setSelectedData(e.data);
      openRefItem.current();
    }
  }

  useEffect(() => {
    console.log("*** FxInfoList ***  title = " + title);
    console.log("*** FxInfoList ***  inform = ", inform);
  }, []);

  return (
    <>
      <div className="FxInfoListDiv">
        <h2>{title}</h2>
        <div className="titleArea">
          <a href="#" className="mini" onClick={() => click("more")}>
            more
          </a>
        </div>
        <ul className="board">
          {inform
            ? inform.map((x, index) => {
                return (
                  <li key={index} onClick={() => click(x)}>
                    <a href={"#"}>
                      <span>{x.title}</span>
                      <span>{x.date}</span>
                    </a>
                  </li>
                );
              })
            : ""}
        </ul>
      </div>
      {props.moreOpId ? (
        <FxPopupOpener openRef={openRefMore} opId={props.moreOpId}>
          <FxResource opId={props.moreOpId} />
        </FxPopupOpener>
      ) : (
        ""
      )}
      {props.itemOpId ? (
        <FxPopupOpener openRef={openRefItem} opId={props.itemOpId}>
          <FxResource opId={props.itemOpId} selectedData={selectedData} />
        </FxPopupOpener>
      ) : (
        ""
      )}
    </>
  );
};
